export const Types = {

  // BONUS GROUP ----------
  //Get - List
  GET_BONUSGROUP_LIST_REQUEST: 'GET_BONUSGROUP_LIST_REQUEST',
  GET_BONUSGROUP_LIST_SUCCESS: 'GET_BONUSGROUP_LIST_SUCCESS',
  GET_BONUSGROUP_LIST_FAIL: 'GET_BONUSGROUP_LIST_FAIL',

  //Set for Update list
  SET_UPDATE_BONUSGROUP_LIST: 'SET_UPDATE_BONUSGROUP_LIST',

  //Store - Add
  POST_BONUSGROUP_ADD_REQUEST: 'POST_BONUSGROUP_ADD_REQUEST',
  POST_BONUSGROUP_ADD_SUCCESS: 'POST_BONUSGROUP_ADD_SUCCESS',
  POST_BONUSGROUP_ADD_FAIL: 'POST_BONUSGROUP_ADD_FAIL',

  //Update - Edit
  PUT_BONUSGROUP_EDIT_REQUEST: 'PUT_BONUSGROUP_EDIT_REQUEST',
  PUT_BONUSGROUP_EDIT_SUCCESS: 'PUT_BONUSGROUP_EDIT_SUCCESS',
  PUT_BONUSGROUP_EDIT_FAIL: 'PUT_BONUSGROUP_EDIT_FAIL',

  //Delete
  DELETE_BONUSGROUP_DEL_REQUEST: 'DELETE_BONUSGROUP_DEL_REQUEST',
  DELETE_BONUSGROUP_DEL_SUCCESS: 'DELETE_BONUSGROUP_DEL_SUCCESS',
  DELETE_BONUSGROUP_DEL_FAIL: 'DELETE_BONUSGROUP_DEL_FAIL',

  //CLear 
  CLEAR_ALL_REQUEST: 'CLEAR_ALL_REQUEST',
};

const INITIAL_STATE = {

  // BONUS GROUP ----------
  dataBonusGroupList: [],
  loadingBonusGroupList: false,
  errorBonusGroupList: false,
  errorDataBonusGroupList: false,
  dataBonusGroupListUpdate: false,

  loadingBonusGroupAdd: false,
  errorBonusGroupAdd: false,
  errorDataBonusGroupAdd: false,

  loadingBonusGroupEdit: false,
  errorBonusGroupEdit: false,
  errorDataBonusGroupEdit: false,

  loadingBonusGroupDelete: false,
  errorBonusGroupDelete: false,
  errorDataBonusGroupDelete: false,

};

export default function bonus_group(state = INITIAL_STATE, action) {
  switch (action.type) {

    // BONUS GROUP ----------
    //Get - List
    case Types.GET_BONUSGROUP_LIST_REQUEST:
      return {
        ...state,
        loadingBonusGroupList: true,
        errorBonusGroupList: false,
      };
    case Types.GET_BONUSGROUP_LIST_SUCCESS:
      return {
        ...state,
        dataBonusGroupList: action.payload,
        loadingBonusGroupList: false,
        errorBonusGroupList: false,
        errorDataBonusGroupList: false
      };
    case Types.GET_BONUSGROUP_LIST_FAIL:
      return {
        ...state,
        dataBonusGroupList: false,
        loadingBonusGroupList: false,
        errorBonusGroupList: true,
        errorDataBonusGroupList: action.payload,
      };

    case Types.SET_UPDATE_BONUSGROUP_LIST:
      return {
        ...state,
        dataBonusGroupListUpdate: action.payload,
      };

    //Store - Add
    case Types.POST_BONUSGROUP_ADD_REQUEST:
      return {
        ...state,
        loadingBonusGroupAdd: true,
        errorBonusGroupAdd: false,
      };
    case Types.POST_BONUSGROUP_ADD_SUCCESS:
      return {
        ...state,
        loadingBonusGroupAdd: false,
        errorBonusGroupAdd: false,
        errorDataBonusGroupAdd: false,
      };
    case Types.POST_BONUSGROUP_ADD_FAIL:
      return {
        ...state,
        loadingBonusGroupAdd: false,
        errorBonusGroupAdd: true,
        errorDataBonusGroupAdd: action.payload,
      };

    //Update - Edit
    case Types.PUT_BONUSGROUP_EDIT_REQUEST:
      return {
        ...state,
        loadingBonusGroupEdit: true,
        errorBonusGroupEdit: false,
      };
    case Types.PUT_BONUSGROUP_EDIT_SUCCESS:
      return {
        ...state,
        loadingBonusGroupEdit: false,
        errorBonusGroupEdit: false,
        errorDataBonusGroupEdit: false,
      };
    case Types.PUT_BONUSGROUP_EDIT_FAIL:
      return {
        ...state,
        loadingBonusGroupEdit: false,
        errorBonusGroupEdit: true,
        errorDataBonusGroupEdit: action.payload,
      };

    //Delete 
    case Types.DELETE_BONUSGROUP_DEL_REQUEST:
      return {
        ...state,
        loadingBonusGroupDelete: true,
        errorBonusGroupDelete: false,
      };
    case Types.DELETE_BONUSGROUP_DEL_SUCCESS:
      return {
        ...state,
        loadingBonusGroupDelete: false,
        errorBonusGroupDelete: false,
        errorDataBonusGroupDelete: false,
      };
    case Types.DELETE_BONUSGROUP_DEL_FAIL:
      return {
        ...state,
        loadingBonusGroupDelete: false,
        errorBonusGroupDelete: true,
        errorDataBonusGroupDelete: action.payload,
      };

    //Clear
    case Types.CLEAR_ALL_REQUEST:
      return {
        ...state,

        // BONUS GROUP ----------
        dataBonusGroupList: [],
        loadingBonusGroupList: false,
        errorBonusGroupList: false,
        errorDataBonusGroupList: false,
        dataBonusGroupListUpdate: false,

        loadingBonusGroupAdd: false,
        errorBonusGroupAdd: false,
        errorDataBonusGroupAdd: false,

        loadingBonusGroupEdit: false,
        errorBonusGroupEdit: false,
        errorDataBonusGroupEdit: false,

        loadingBonusGroupDelete: false,
        errorBonusGroupDelete: false,
        errorDataBonusGroupDelete: false,

      };

    default:
      return state;
  }
}

export const Creators = {

  // DICOUNT GROUP ----------
  //Get - List
  getBonusGroupListRequest: (payload) => ({
    type: Types.GET_BONUSGROUP_LIST_REQUEST,
    payload,
  }),

  getBonusGroupListRequestSuccess: (payload) => ({
    type: Types.GET_BONUSGROUP_LIST_SUCCESS,
    payload,
  }),

  getBonusGroupListRequestFail: (payload) => ({
    type: Types.GET_BONUSGROUP_LIST_FAIL,
    payload,
  }),

  setUpdateBonusGroup: (payload) => ({
    type: Types.SET_UPDATE_BONUSGROUP_LIST,
    payload,
  }),

  //Store - Add 
  postBonusGroupAddRequest: (payload) => ({
    type: Types.POST_BONUSGROUP_ADD_REQUEST,
    payload,
  }),

  postBonusGroupAddRequestSuccess: () => ({
    type: Types.POST_BONUSGROUP_ADD_SUCCESS,
  }),

  postBonusGroupAddRequestFail: (payload) => ({
    type: Types.POST_BONUSGROUP_ADD_FAIL,
    payload,
  }),

  //Update - Edit 
  putBonusGroupEditRequest: (payload) => ({
    type: Types.PUT_BONUSGROUP_EDIT_REQUEST,
    payload,
  }),

  putBonusGroupEditRequestSuccess: () => ({
    type: Types.PUT_BONUSGROUP_EDIT_SUCCESS,
  }),

  putBonusGroupEditRequestFail: (payload) => ({
    type: Types.PUT_BONUSGROUP_EDIT_FAIL,
    payload,
  }),

  //Delete 
  deleteBonusGroupDelRequest: (payload) => ({
    type: Types.DELETE_BONUSGROUP_DEL_REQUEST,
    payload,
  }),

  deleteBonusGroupDelRequestSuccess: () => ({
    type: Types.DELETE_BONUSGROUP_DEL_SUCCESS,
  }),

  deleteBonusGroupDelRequestFail: (payload) => ({
    type: Types.DELETE_BONUSGROUP_DEL_FAIL,
    payload,
  }),

  //Clear
  clearAllRequest: () => ({
    type: Types.CLEAR_ALL_REQUEST
  }),
};
